// Module
var code = `<div class="jumbotron-surface scene-player-log-surface">

  <!-- The colour of the scene is the only inline colour of this panel. It is on
       the edge below the head, so the operator sees which scene the panel is for. -->
  <div class="jumbotron-panel-head has-scene-colour scene-player-log-head" ng-style="{'border-bottom-color': \$ctrl.scene.color}">
    <div class="scene-player-log-head-main" ng-click="\$ctrl.isCollapsed = !\$ctrl.isCollapsed">
      <i class="fas fa-fw scene-player-log-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': \$ctrl.isCollapsed, 'fa-chevron-down': !\$ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading scene-player-log-title">Scene log</span>
    </div>

    <div class="scene-player-log-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary"
        ng-click="\$event.stopPropagation(); \$ctrl.resetPlaylistHead()"
        title="Restart playlist from the first item">
        <i class="fas fa-rotate-left" aria-hidden="true"></i> Reset queue
      </button>
    </div>
  </div>

  <div class="scene-player-log-body" ng-show="!\$ctrl.isCollapsed">
    <table class="jumbotron-table scene-player-log-table">
      <thead>
        <tr>
          <th class="jumbotron-table-head-cell scene-player-log-icon-cell"></th>
          <th class="jumbotron-table-head-cell">Name</th>
          <th class="jumbotron-table-head-cell jumbotron-number-cell scene-player-log-time">Start</th>
          <th class="jumbotron-table-head-cell jumbotron-number-cell scene-player-log-time">End</th>
        </tr>
      </thead>
      <tbody>
        <tr class="scene-player-log-row" ng-repeat="item in \$ctrl._\$scope.playListLog"
          ng-class="{
            'is-playing': \$ctrl.scene && \$ctrl.scene.currentlyPlayingId == item.id,
            'is-removed': item.removed === true && \$ctrl.scene && \$ctrl.scene.currentlyPlayingId != item.id
          }">
          <td class="jumbotron-table-cell scene-player-log-icon-cell">
            <i class="jumbotron-live-mark fas fa-play" aria-hidden="true"
              ng-if="\$ctrl.scene && \$ctrl.scene.currentlyPlayingId == item.id"></i>
            <i class="fas" aria-hidden="true" ng-class="\$ctrl.iconFor(item.type)"
              ng-if="!(\$ctrl.scene && \$ctrl.scene.currentlyPlayingId == item.id)"></i>
          </td>
          <td class="jumbotron-table-cell scene-player-log-name-cell" title="{{item.itemName}}">{{item.itemName}}</td>
          <td class="jumbotron-table-cell jumbotron-number-cell scene-player-log-time">{{item.timePlayed | amDateFormat:'HH:mm:ss'}}</td>
          <td class="jumbotron-table-cell jumbotron-number-cell scene-player-log-time">{{item.playbackEnded | amDateFormat:'HH:mm:ss'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
`;
// Exports
export default code;